export interface Product {
  id: string;
  name: string;
  slogan: string;
  highlights: string[];
  category: 'strategic' | 'foundation' | 'marketing' | 'fishery';
  icon: string;
  url?: string;
  wechatTip?: string;
  tags?: string[];
  layer?: string;
  value?: string;
  audience?: string;
  links?: { label: string; url?: string }[];
  status?: string;
}

export const products: Product[] = [
  {
    id: 'strategy-2026',
    name: '2026战略框架',
    slogan: '从技术确定性到资产确定性',
    highlights: ['战略导读', '战略执行', '运行协同'],
    category: 'strategic',
    icon: 'ri-compass-3-line',
    url: 'http://lysos.luyuaqua.com',
    tags: ['战略规划', '执行协同', '目标管理'],
    layer: '战略引擎',
    value: '陆渔科技2026年战略框架，从技术确定性到资产确定性的完整路径规划，通过战略导读、战略执行和运行协同，确保战略目标层层分解、有效落地。',
    audience: '企业全员、战略部门',
    links: [
      { label: '2026战略框架', url: 'http://lysos.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'org-structure',
    name: '动态组织架构平台',
    slogan: '全景展示公司每位员工的项目、角色归属',
    highlights: ['项目协作全图', '员工角色图谱', '人才判断', '动态组织管理', 'AI助手'],
    category: 'strategic',
    icon: 'ri-flow-chart',
    url: 'http://129.204.149.109:9030',
    tags: ['组织架构', '人才管理', 'AI助手'],
    layer: '战略引擎',
    value: '全景展示公司每位员工的项目、角色归属，通过项目协作全图、员工角色图谱和人才判断，实现动态组织管理和AI辅助决策，支撑企业战略落地。',
    audience: '企业管理层、HR团队',
    links: [
      { label: '动态组织架构', url: 'http://129.204.149.109:9030' },
    ],
    status: '已上线',
  },
  {
    id: 'auaa',
    name: '陆渔·确定性农业引擎',
    slogan: '陪你开启确定性农业之旅',
    highlights: ['第二大脑Agent', '项目落地指南', '行业智库', '渔王百宝箱', '生态集市', 'AUAA联盟'],
    category: 'strategic',
    icon: 'ri-rocket-2-line',
    url: 'https://agrisure.luyuaqua.com/',
    tags: ['战略引擎', '品牌门户', '联盟生态'],
    layer: '战略引擎',
    value: '作为确定性农业的顶层战略平台，AUAA引擎整合了品牌运营、行业智库、渔王百宝箱、生态集市等核心模块，为企业和个人提供从认知到行动的全链路确定性支撑。它是整个产品矩阵的灵魂所在，连接着所有下游产品与业务场景。',
    audience: '企业决策者、行业合作伙伴',
    links: [
      { label: '确定性农业引擎', url: 'https://agrisure.luyuaqua.com/' },
      { label: '管理后台', url: 'https://agrisure.luyuaqua.com/admin/login' },
    ],
    status: '已上线',
  },
  {
    id: 'super-individual',
    name: '超级个体监测系统',
    slogan: '追踪每一位员工向超级个体的跃迁过程',
    highlights: ['超级个体转型概览', 'Agent库', 'Skill库', '实践案例'],
    category: 'foundation',
    icon: 'ri-user-star-line',
    url: 'https://ai-monitor.luyuaqua.com',
    tags: ['人才发展', 'AI赋能', '技能追踪'],
    layer: '基础能力',
    value: '追踪每一位员工向超级个体的跃迁过程，通过超级个体转型概览、Agent库和Skill库，帮助员工持续提升AI应用能力，实现个人价值最大化。',
    audience: '企业员工、HR团队',
    links: [
      { label: '超级个体监测', url: 'https://ai-monitor.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'second-brain',
    name: '第二大脑',
    slogan: 'Where Knowledge Comes to You',
    highlights: ['认知中枢', '决策引擎', '权威发布', '品牌运营', '销售罗盘', 'Second Brain AI'],
    category: 'foundation',
    icon: 'ri-brain-line',
    url: 'https://secondbrain.luyuaqua.com',
    tags: ['知识管理', '认知中枢', '品牌运营'],
    layer: '基础能力',
    value: '打造企业的知识中枢和决策引擎，通过权威发布、品牌运营、销售罗盘等模块，将碎片知识转化为可执行的商业洞察，支撑全域业务增长。',
    audience: '知识工作者、品牌运营人员',
    links: [
      { label: '第二大脑', url: 'https://secondbrain.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'leo',
    name: 'LEO工作站',
    slogan: '让每一份工作都拥有AI的加速度',
    highlights: ['AI问答', '知识库管理', '智能体管理', '最全最强大模型', '数字员工'],
    category: 'foundation',
    icon: 'ri-robot-2-line',
    url: 'https://weknora.luyuaqua.com',
    tags: ['AI办公', '知识库', '智能体'],
    layer: '基础能力',
    value: '一站式AI工作平台，集成AI问答、知识库管理、智能体管理和多模型能力，让每个员工都拥有专属数字员工，大幅提升日常工作效率。',
    audience: '企业员工、个人用户',
    links: [
      { label: 'LEO工作站', url: 'https://weknora.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'task-board',
    name: '任务看板系统',
    slogan: '追踪每一位员工的投入产出',
    highlights: ['人员任务', '能效指标', '评价体系'],
    category: 'foundation',
    icon: 'ri-list-check-2',
    url: 'https://luyuboard.luyuaqua.com',
    tags: ['任务管理', '效能追踪', '绩效评价'],
    layer: '基础能力',
    value: '追踪每一位员工的投入产出，通过人员任务管理、能效指标监控和评价体系，实现工作过程可视化和成果量化，提升团队整体执行力。',
    audience: '项目管理者、团队负责人',
    links: [
      { label: '任务看板', url: 'https://luyuboard.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'data-cockpit',
    name: '数据驾驶舱',
    slogan: '智能驱动，AI赋能，科技引领农业未来',
    highlights: ['AI应用统计', '用户活跃统计', '热启动', '智能客服', 'SalesMind', '渔全览', 'AIC调用统计'],
    category: 'foundation',
    icon: 'ri-pie-chart-2-line',
    url: 'https://stats.luyuaqua.com',
    tags: ['数据可视化', '统计分析', '运营监控'],
    layer: '基础能力',
    value: '智能驱动，AI赋能，科技引领农业未来。聚合AI应用统计、用户活跃统计、热启动、智能客服、SalesMind、渔全览、AIC等多产品调用数据，为管理层提供全景运营决策视图。',
    audience: '管理层、运营团队',
    links: [
      { label: '数据驾驶舱', url: 'https://stats.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'official',
    name: '陆渔科技官网',
    slogan: '确定性农业开创者',
    highlights: ['企业愿景', '科技引领', '绿色发展', '智领渔业未来', '一站式解决方案'],
    category: 'marketing',
    icon: 'ri-global-line',
    url: 'https://luyuaqua.com',
    tags: ['品牌门户', '企业展示', '解决方案'],
    layer: '品牌营销',
    value: '陆渔科技品牌门户，集中展示企业愿景、科技实力、绿色发展理念和一站式解决方案，是外部了解确定性农业的核心窗口。',
    audience: '潜在客户、行业伙伴',
    links: [
      { label: '陆渔科技官网', url: 'https://luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'makeover',
    name: '失败水面重生计划',
    slogan: '用确定性工程体系接管全国失败水面资产',
    highlights: ['计划介绍', '战略背景', '战略定义', '战略路径', '部门执行', '实施动态', '技改申请'],
    category: 'marketing',
    icon: 'ri-refresh-line',
    url: 'https://makeover.luyuaqua.com',
    tags: ['资产盘活', '技改服务', '战略项目'],
    layer: '品牌营销',
    value: '用确定性工程体系接管全国失败水面资产，通过计划介绍、战略路径规划和技改申请流程，帮助搁浅水面项目重新焕发生命力，实现资产价值最大化。',
    audience: '水面资产持有者、投资者',
    links: [
      { label: '失败水面重生', url: 'https://makeover.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'guiyu',
    name: '鳜鱼启航引擎',
    slogan: '陆渔科技确定性农业的商业化落地样本',
    highlights: ['鳜鱼启航计划', '五重保障', '养殖方案', '案例介绍', '工具及产品中心'],
    category: 'marketing',
    icon: 'ri-ship-line',
    wechatTip: '微信小程序',
    tags: ['渔业营销', '商业化落地', '五重保障'],
    layer: '品牌营销',
    value: '确定性农业商业化落地的标杆样本，通过鳜鱼启航计划和五重保障体系，为养殖户提供从规划到销售的完整商业闭环。',
    audience: '鳜鱼养殖户、经销商',
    links: [
      { label: '微信小程序', url: 'wechat://鳜鱼启航引擎' },
    ],
    status: '已上线',
  },
  {
    id: 'customer-service',
    name: '智能客服',
    slogan: 'AI驱动的全链路客户转化引擎',
    highlights: ['意图识别', '回应话术', '内容推荐', '留资跳转', '销售线索捕捉'],
    category: 'marketing',
    icon: 'ri-customer-service-2-line',
    url: 'https://csa.luyuaqua.com',
    tags: ['智能客服', '客户转化', '销售线索'],
    layer: '品牌营销',
    value: 'AI驱动的全链路客户转化引擎，通过意图识别、智能应答、内容推荐和留资跳转，实现从咨询到成交的高效转化。',
    audience: '销售团队、客服部门',
    links: [
      { label: '智能客服', url: 'https://csa.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'traffic',
    name: '流量驱动系统',
    slogan: '用算法撬动流量自然增长',
    highlights: ['爆款视频解析', '二次改写', '热启动评论生成', '抖音热启动', '任务驱动'],
    category: 'marketing',
    icon: 'ri-line-chart-line',
    url: 'http://ai-web.luyuaqua.com',
    tags: ['流量增长', '内容营销', '数据驱动'],
    layer: '品牌营销',
    value: '基于AI算法的内容营销增长引擎，通过爆款解析、智能改写、评论生成等功能，帮助品牌在抖音等平台实现流量自然增长。',
    audience: '内容运营、品牌营销',
    links: [
      { label: '流量驱动系统', url: 'http://ai-web.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'salesmind',
    name: 'SalesMind',
    slogan: 'Your deal, already known',
    highlights: ['成交潜力画像', '统计视图', '客户池管理', '公海池管理', 'AI参谋'],
    category: 'marketing',
    icon: 'ri-mind-map',
    url: 'https://salesmind.luyuaqua.com',
    tags: ['销售管理', '客户画像', 'AI参谋'],
    layer: '品牌营销',
    value: '智能销售管理系统，通过成交潜力画像、客户池管理和AI参谋功能，让每一笔交易都有据可依、有章可循。',
    audience: '销售团队、业务管理',
    links: [
      { label: 'SalesMind', url: 'https://salesmind.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'rcu600-share',
    name: 'RCU600-ONE 产品落地页',
    slogan: '先验证再决策，可租可售',
    highlights: ['第一阶段验证体系', '真实生产验证', '可租可售', '降低决策风险'],
    category: 'fishery',
    icon: 'ri-pages-line',
    url: 'https://rcu600one-share.luyuaqua.ai',
    tags: ['产品展示', '验证体系', '可租可售'],
    layer: '渔业领域',
    value: 'RCU600-ONE是一套面向真实生产的第一阶段验证体系，通过先验证再决策、可租可售的灵活模式，帮助客户降低投资风险，快速验证养殖方案可行性。',
    audience: '潜在养殖户、投资者',
    links: [
      { label: 'RCU600-ONE落地页', url: 'https://rcu600one-share.luyuaqua.ai' },
    ],
    status: '已上线',
  },
  {
    id: 'rcu600-ai',
    name: 'RCU600-ONE AI',
    slogan: '超级老师傅替你做判断',
    highlights: ['看水质', '看投喂', '看鱼况', '看系统', '紧急问题联系工程师', '渔王值权益兑换'],
    category: 'fishery',
    icon: 'ri-magic-line',
    url: 'http://129.204.149.109:9040',
    tags: ['AI养殖', '智能判断', '渔王值'],
    layer: '渔业领域',
    value: 'RCU600-ONE的AI养殖大脑，超级老师傅替你做判断。通过看水质、看投喂、看鱼况、看系统，结合紧急问题联系陆渔工程师和渔王值权益兑换，实现养殖全程智能化决策。',
    audience: '养殖场负责人、技术员',
    links: [
      { label: 'RCU600-ONE AI', url: 'http://129.204.149.109:9040' },
    ],
    status: '已上线',
  },
  {
    id: 'rcu600-workbench',
    name: 'RCU600-ONE 工作台',
    slogan: 'AI 驱动知识与协同平台',
    highlights: ['总纲中枢', '商业模式', '执行引擎', '信息同步与澄清', '项目成果物'],
    category: 'fishery',
    icon: 'ri-briefcase-line',
    url: 'https://rcu600.luyuaqua.com',
    tags: ['协同平台', '项目管理', '知识驱动'],
    layer: '渔业领域',
    value: 'RCU600-ONE的AI驱动知识与协同平台，通过总纲中枢、商业模式梳理、执行引擎工作台和信息同步，确保项目成果物高效产出和团队协同一致。',
    audience: '项目团队、管理人员',
    links: [
      { label: 'RCU600-ONE工作台', url: 'https://rcu600.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'aic',
    name: 'AIC智能控制系统',
    slogan: '你的超级老师傅，决策不再凭感觉',
    highlights: ['养殖规划', '任务管理', '设备管控', 'AI分析', '风险预警', '策略推送'],
    category: 'fishery',
    icon: 'ri-settings-3-line',
    url: 'https://voyage.luyuaqua.com',
    tags: ['智能控制', 'AI决策', '风险预警'],
    layer: '渔业领域',
    value: '养殖场的超级老师傅，通过AI分析、风险预警和策略推送，让养殖决策从经验驱动升级为数据驱动。',
    audience: '养殖场负责人、技术员',
    links: [
      { label: 'AIC智能控制', url: 'https://voyage.luyuaqua.com' },
      { label: 'H5移动端', url: 'https://h5.voyage.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'pdm',
    name: 'PdM泵组预测性维护系统',
    slogan: '守住系统真正的"生命线"',
    highlights: ['振动监测', '温度监测', '提前预警', '故障预测', '保障稳定'],
    category: 'fishery',
    icon: 'ri-pulse-line',
    tags: ['预测维护', '振动监测', '故障预测'],
    layer: '渔业领域',
    value: '基于振动和温度数据的泵组预测性维护系统，通过提前预警和故障预测，守住循环水系统的真正生命线。',
    audience: '设备维护团队',
    links: [
      { label: '即将上线', url: undefined },
    ],
    status: '研发中',
  },
  {
    id: 'yuce',
    name: '渔策',
    slogan: '验证你的RAS设想',
    highlights: ['养殖规划', '养殖目标', '投资预算', '可视化方案', '养殖挑战分析'],
    category: 'fishery',
    icon: 'ri-file-chart-line',
    url: 'http://yuce.luyuaqua.com',
    tags: ['养殖规划', '投资分析', '方案设计'],
    layer: '渔业领域',
    value: '智能养殖规划平台，通过养殖目标设定、投资预算分析和可视化方案设计，帮助养殖户科学制定RAS循环水养殖规划。',
    audience: '养殖户、投资者',
    links: [
      { label: '渔策', url: 'http://yuce.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'fishview',
    name: '渔全览',
    slogan: '你的每日养殖全景报告',
    highlights: ['数据采集', '智能分析', '策略输出', '水质监测', '生长追踪', 'AI决策模型'],
    category: 'fishery',
    icon: 'ri-dashboard-line',
    url: 'http://fishview.luyuaqua.com',
    tags: ['数据驾驶舱', '智能分析', '策略输出'],
    layer: '渔业领域',
    value: '每日养殖全景数据驾驶舱，通过数据采集、智能分析和策略输出，让养殖户实时掌握养殖全局，做出科学决策。',
    audience: '养殖管理人员、技术员',
    links: [
      { label: '渔全览', url: 'http://fishview.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'vivian',
    name: '渔维',
    slogan: '设备维护工单全链路跟踪处理',
    highlights: ['快捷提单', '合理派发', 'AI识别', '自动派单', '运维指引', '问题定位'],
    category: 'fishery',
    icon: 'ri-tools-line',
    url: 'http://vivian.luyuaqua.com',
    tags: ['运维管理', '工单系统', 'AI派单'],
    layer: '渔业领域',
    value: '设备维护工单全链路管理系统，通过快捷提单、AI识别和自动派单，大幅提升运维效率和设备稳定性。',
    audience: '运维团队、设备管理',
    links: [
      { label: '渔维', url: 'http://vivian.luyuaqua.com' },
    ],
    status: '已上线',
  },
  {
    id: 'water-monitor',
    name: '水质监测系统',
    slogan: '智慧养殖数字化平台',
    highlights: ['项目概览', '生产养殖', '远程监管', '实时监测', '多端访问'],
    category: 'fishery',
    icon: 'ri-water-percent-line',
    url: 'http://129.204.149.109:5001/?base=%E5%AE%89%E5%BE%BD%E5%AE%89%E5%BA%86%E5%9F%BA%E5%9C%B0',
    tags: ['水质监测', '远程监管', '多端访问'],
    layer: '渔业领域',
    value: '智慧养殖水质监测数字化平台，支持项目概览、生产养殖管理和远程实时监测，实现养殖环境的全面数字化管控。',
    audience: '养殖管理人员',
    links: [
      { label: '水质监测系统', url: 'http://129.204.149.109:5001/?base=%E5%AE%89%E5%BE%BD%E5%AE%89%E5%BA%86%E5%9F%BA%E5%9C%B0' },
    ],
    status: '已上线',
  },
];
